<template>
  <div class="main">
    <report-top>
      <ly-search slot="search" v-model="searchItem.keyword" @search="search"></ly-search></report-top>
    <selectTool ref="selectTool"><template slot="btn"><Button @click="getSearchItem" type="error"
          class="chaxun">查询</Button><Button @click="openAdd" type="primary" class="chaxun">新增</Button></template>
    </selectTool>

    <Table border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)">
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="openBlind(row)"> 绑定 </Button>
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page :current="1" :total="total" :page-size="searchItem.pageSize" :page-size-opts="[10, 50, 100]" show-total
          show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange"></Page>
      </div>
    </div>
    <form-model :title="isAdd ? '新增趟次' : '编辑趟次'" width="1200" ref="formModel">
      <selectLine slot="routeId" :id="item.routeId" @update:id="item.routeId = $event">
      </selectLine>
      <template slot="fwdMarkerList">
        <div class="btnwrap">
          <Dropdown>
            <Button size="small">新增站点</Button>
            <template #list>
              <DropdownMenu>
                <DropdownItem><span @click="
                  openPoint = true;
                now = 'fwdMarkerList';
                ">从标注点引入</span>
                </DropdownItem>
                <DropdownItem>
                  <span @click="addPoints('fwdMarkerList')">自行搜索地址</span>
                </DropdownItem>
              </DropdownMenu>
            </template>
          </Dropdown>
          <Button size="small" v-show="item.fwdMarkerList.length > 1" @click="
            openAuto = true;
          now = 'fwdMarkerList';
          $refs.autoSet.reach(item[now]);
          ">智能排序</Button>
          <Button size="small" v-show="item.fwdMarkerList.length > 1" @click="
            openDrawer = true;
          now = 'fwdMarkerList';
          $refs.handSet.reach(item[now]);
          ">拖动排序</Button>

          <Button size="small" v-show="item.fwdMarkerList.length > 1" @click="fanzhuan('fwdMarkerList')">翻转站点</Button>
          <Button size="small" v-show="item.fwdMarkerList.length > 0" @click="item.fwdMarkerList = []">清空站点</Button>

          <Tooltip content="根据正向站点自动生成">
            <Button size="small" v-show="item.bwdMarkerList.length > 1"
              @click="autoStation('fwdMarkerList', 'bwdMarkerList')" title="根据反向站点自动生成相对应的正向站点">自动生成</Button>
          </Tooltip>
          <span class="tishi">站点必须≥2个</span>
        </div>

        <div class="stationWrap">
          <div class="stationWrapline"></div>

          <div class="stations">
            <station v-for="(x, index1) in item.fwdMarkerList" :key="index1" :station="x"
              @del="item.fwdMarkerList.splice(index1, 1)" @update="update(index1, 'fwdMarkerList')">{{ fsdc(index1,
                item.fwdMarkerList.length - 1) }}</station>
          </div>
        </div>
      </template>

      <template slot="bwdMarkerList">
        <div class="btnwrap">
          <Dropdown>
            <Button size="small">新增站点</Button>
            <template #list>
              <DropdownMenu>
                <DropdownItem><span @click="
                  openPoint = true;
                now = 'bwdMarkerList';
                ">从标注点引入</span>
                </DropdownItem>
                <DropdownItem>
                  <span @click="addPoints('bwdMarkerList')">自行搜索地址</span>
                </DropdownItem>
              </DropdownMenu>
            </template>
          </Dropdown>
          <Button size="small" v-show="item.bwdMarkerList.length > 1" @click="
            openAuto = true;
          now = 'bwdMarkerList';
          $refs.autoSet.reach(item[now]);
          ">智能排序</Button>
          <Button size="small" v-show="item.bwdMarkerList.length > 1" @click="
            openDrawer = true;
          now = 'bwdMarkerList';
          $refs.handSet.reach(item[now]);
          ">拖动排序</Button>

          <Button size="small" v-show="item.bwdMarkerList.length > 1" @click="fanzhuan('bwdMarkerList')">翻转站点</Button>
          <Button size="small" v-show="item.bwdMarkerList.length > 0" @click="item.bwdMarkerList = []">清空站点</Button>

          <Tooltip content="根据正向站点自动生成">
            <Button size="small" v-show="item.fwdMarkerList.length > 1"
              @click="autoStation('bwdMarkerList', 'fwdMarkerList')">自动生成</Button>
          </Tooltip>
          <span class="tishi" type="text">返程不计趟次的请忽略该项</span>
        </div>

        <div class="stationWrap">
          <div class="stationWrapline"></div>

          <div class="stations">
            <station v-for="(x, index1) in item.bwdMarkerList" :key="index1" :station="x"
              @del="item.bwdMarkerList.splice(index1, 1)" @update="update(index1, 'bwdMarkerList')">{{ fsdc(index1,
                item.bwdMarkerList.length - 1) }}</station>
          </div>
        </div>
      </template>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>

    <Drawer v-model="openAuto" title="请选择起始点" class="my-drawer">
      <autoSet ref="autoSet" @result="
        item[now] = $event;
      openAuto = false;
      "></autoSet>
    </Drawer>
    <Drawer v-model="openDrawer" class="my-drawer" title="拖动站点排序">
      <handSet ref="handSet" @result="
        item[now] = $event;
      openDrawer = false;
      "></handSet>
    </Drawer>
    <selectMapTool ref="addPoints" @add="reAdd"></selectMapTool>
    <Modal v-model="openPoint" footer-hide width="1200" fullscreen>
      <point v-if="openPoint" :scan="true" :checkMore="true" @objs="reobj"></point>
    </Modal>
    <form-model width="1200" ref="myForm" title="修改站点信息">
      <div style="width: 100%; height: 400px" slot="map">
        <lypoint ref="mypoint"></lypoint>
      </div>
      <Input slot="address" v-model="stationItem.address">
      <template #suffix>
        <Button @click="autoGetAddress">自动获取</Button>
      </template>
      </Input>
      <Button slot="btn" type="primary" @click="updateStaion">确认修改</Button>
    </form-model>
    <blind ref="blind" v-model="deviceList" @blind="blind"></blind>
  </div>
</template>
<script>
import station from "./station.vue";
import autoSet from "./autoSet.vue";
import handSet from "./handSet.vue";
//import selectMapTool from "./selectMapTool.vue";
import point from "../rule/rulePoint.vue";
import lypoint from "../map/point.vue";
import lypoint20 from "../map20/point.vue";
var vmap = localStorage.getItem('vmap');
var units = [{
  id: 0,
  name: '趟次',
}, {
  id: 1,
  name: '公里',
}, {
  id: 2,
  name: '小时',
}/* , {
  id: 3,
  name: '吨',
}, */
]
export default {
  components: { station, autoSet, handSet, point, lypoint: vmap == 2.0 ? lypoint20 : lypoint },
  data() {
    return {
      isAdd: false,
      openDrawer: false,
      openAuto: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        },
        {
          title: "操作",
          slot: "action",
          sort: 200,
          width: 180,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        name: "",
        remark: "",
        routeId: "",
        bwdMarkerList: [],
        fwdMarkerList: [],
        groupId: 0,
        groupName: "",
        validDuration: 120 * 60,
        validMileage: 0,
        unit:0,
        unitPrice:0,
        startPrice:0,
        id: ''
      },
      forms: [
        {
          title: "所属单位",
          key: "groupId",
          key1: "groupName",
          type: "selectGroup",
          required: true,
          span: 8,
        },
        {
          title: "趟次名称",
          key: "name",
          type: "Input",
          required: true,
          span: 8,
          width: 200,
        },
        {
          title: "超时时长/分",
          key: "validDuration",
          key2: "validDuration2",
          type: "duration",
          beishu: 60,
          required: true,
          span: 8,
          width: 100,
        },
        {
          title: "有效里程/km",
          key: "validMileage",
          type: "InputNumber",
          required: true,
          span: 8,
          width: 100,
        },
        {
          title: "参考线路",
          key: "routeId",
          key2: "routeName",
          slotForm: "routeId",
          span: 8,
          width: 100,
        },
        {
          title: "正向站点",
          key: "fwdMarkerList",
          key2: "fwdMarkers",
          slotForm: "fwdMarkerList",
          span: 24,
          width: 300,
        },
        {
          title: "反向站点",
          key: "bwdMarkerList",
          key2: "bwdMarkers",
          slotForm: "bwdMarkerList",
          span: 24,
          width: 300,
        },
        {
          title: "计价单位",
          key: "unit",//0qita 1lichegn 2shichagn 3zhognl
          key2:'unit1',
          type: "Select",
          selectItems: units,
          selectType:'obj',
          required: true,
          span: 8,
          width: 100,
        }, {
          title: "单价",
          key: "unitPrice",
          type: "InputNumber",
          required: true,
          span: 8,
          width: 100,
        }, {
          title: "起步价",
          key: "startPrice",
          type: "InputNumber",
          required: true,
          span: 8,
          width: 100,
        },
      ],
      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          type: "lyyymmdd",
          times: "2,0",
        },
      ],
      total: 0,
      openPoint: false,
      stationItem: {
        name: "aaa",
        x: 113,
        y: 22,
        radius: 50,
        address: "",
      },
      stationForms: [
        {
          title: "地址简称",
          slotForm: "map",
          span: 24,
          hideLabel: true,
        },
        {
          title: "地址简称",
          key: "name",
          type: "Input",
          required: true,
          span: 6,
          sort: 2,
        },
        {
          title: "半径/米",
          key: "radius",
          type: "Select",
          selectItems: [50, 100, 200, 300, 400, 500, 800, 1000],
          required: true,
          span: 6,
          sort: 2,
        },
        {
          title: "详细地址",
          key: "address",
          slotForm: "address",
          required: false,
          span: 11,
          sort: 2,
        },
      ],
      now: "fwdMarkerList",
      deviceList: [],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.trp + "/timesRule/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        var unit = {};
        for (let i = 0; i < units.length; i++) {
          unit[units[i].id] = units[i].name;

        }
        for (let i = 0; i < data.length; i++) {

          data[i].validDuration2 = Math.ceil(data[i].validDuration / 60);
          //用https://v.car900.com/api/byskplayer.js
          //这种就不允许。报错了
          var fws = [],
            bws = [];
          for (let j = 0; j < data[i].fwdMarkerList.length; j++) {
            fws.push(data[i].fwdMarkerList[j].name);
          }
          for (let j = 0; j < data[i].bwdMarkerList.length; j++) {
            bws.push(data[i].bwdMarkerList[j].name);
          }
          data[i].fwdMarkers = fws.join("=>");
          data[i].bwdMarkers = bws.join("=>");
          data[i].unit1 = unit[data[i].unit]
        }
        this.tableData = data;
        console.log(data);
      });
    },

    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.trp + "/timesRule/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.trp + "/timesRule/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.trp + "/timesRule/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      for (const i in this.item) {
        this.item[i] = row[i];
      }
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    selectCartype(x) {
      this.selectIcon = x.value;
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    fsdc(index, t) {
      if (index == 0) {
        return "起";
      } else if (index == t) {
        return "终";
      } else {
        return "经";
      }
    },
    addPoints(now) {
      this.$refs.addPoints.openMap();
      this.now = now;
    },
    reAdd(v) {
      v.radius = 100;
      v.cs = 2;
      this.item[this.now].splice(1, 0, v);
    },
    reobj(v) {
      var arr = this.item[this.now];
      for (let i = 0; i < v.length; i++) {
        var obj = {
          name: v[i].name,
          address: v[i].address == null ? "暂无详细地址" : v[i].address,
          radius: v[i].radius,
          x: v[i].x,
          y: v[i].y,
          cs: 2,
        };
        arr.push(obj);
      }

      arr = arr.filter(
        (item, index) => arr.findIndex((i) => i.name === item.name) === index
      );
      //this.paixu();
      this.openPoint = false;
    },
    fanzhuan(v) {
      this.item[v].reverse();
    },
    autoStation(a, b) {
      this.item[a] = JSON.parse(JSON.stringify(this.item[b])).reverse();
    },
    //更新站点
    update(index, now) {
      this.stationItem = this.item[now][index];
      this.$refs.myForm.reach(this.stationForms, this.stationItem);

      setTimeout(() => {
        this.$refs.mypoint.drawMap(this.stationItem);
      }, 200);
    },
    //更新站点
    updateStaion() {
      var a = this.$refs.myForm.getItem();
      if (!a) {
        return;
      }
      var ccc = this.$refs.mypoint.getPoint();
      this.stationItem.x = ccc.x;
      this.stationItem.y = ccc.y;

      this.$refs.myForm.close();
    },
    getItem(row, type) {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.trp + "/timesRule/item",
        data: { id: row.id },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          if (type == 1) {
            var data = res.data.data.fenceRuleList;
            var arr = [];
            for (let i = 0; i < data.length; i++) {
              arr.push(data[i].id);
            }
            this.item.fenceRuleIdList = arr;
            this.openForm = true;
          } else {
            var d = res.data.data.deviceList;
            this.deviceList = [];
            for (let i = 0; i < d.length; i++) {
              var obj = {
                id: d[i].deviceId,
                name: d[i].bindAttr,
                key: d[i].deviceId,
                useType: d[i].useType,
              };
              this.deviceList.push(obj);
            }
            this.$refs.blind.open(row);
          }
        }
      });
    },
    openBlind(row) {
      this.getItem(row);
      this.blindId = row.id;
    },
    blind(data) {
      this.utils.loading(this, "处理中");
      var deviceIdList = [];
      for (let i = 0; i < data.length; i++) {
        deviceIdList.push(data[i].id);
      }
      this.axios({
        method: "post",
        url: this.axios.trp + "/timesRule/bind",
        data: { deviceIdList: deviceIdList, id: this.blindId },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
      });
    },
    autoGetAddress() {
      var ccc = this.$refs.mypoint.getPoint();
      var pointList = [
        {
          x: ccc.x,
          y: ccc.y,
        },
      ];

      this.utils.jiexi(pointList).then((data) => {
        this.stationItem.address =
          data[0].address == null ? "暂无地址" : data[0].address;
      });
    },
  },
  mounted() {
    var config = {
      min: 100,
      max: 300,
    };
    this.columns = this.utils.cols(this.forms, this.columns);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
  },
  computed: {
    radius() {
      return this.stationItem.radius;
    },
  },
  watch: {
    radius(v) {
      setTimeout(() => {
        this.$refs.mypoint.drawCir(v);
      }, 500);

    },
  },
};
</script>
<style>
.stationWrap {
  position: relative;
}

.stationWrap .stations {
  margin: 0 auto;
  position: relative;
  display: flex;
  height: 120px;
  border-bottom: solid 1px #ccc;
}

.btnwrap {
  margin-bottom: 10px;
}

.btnwrap .tishi {
  color: red;
  padding: 6px;
}

.stationWrapline {
  position: absolute;
  width: 100%;
  height: 6px;
  background: #77c0ed;
  top: 6px;
  z-index: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/tangci/tangciguize.vue